const baseURL = process.env.REACT_APP_BASE_URL;

export function getAuthToken() {
    return localStorage.getItem("token") || "";
}

// Fetch Year Suggestions
export const fetchPublisherYearSuggestions = async (prefix, publisher) => {

    const token = localStorage.getItem("token") || "";
    const axios = (await import("axios")).default;

    try {
        const response = await axios.post(
            `${baseURL}/quick-search/citation-year-suggestion?size=50`,
            { prefix, publisher },
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return response.data || [];
    } catch (error) {
        console.error("Error fetching citation year suggestions:", error);
        return [];
    }
};

// Fetch Publisher Suggestions
export const fetchPublisherSuggestions = async (prefix, citationLocalYear) => {
    const token = localStorage.getItem("token") || "";
    const axios = (await import("axios")).default;

    const payload = {
        prefix,
        year: citationLocalYear,
    };

    const url = `${baseURL}/quick-search/citation-publisher-suggestion?size=50`;

    try {
        const response = await axios.post(
            url,
            payload,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return response.data || [];
    } catch (error) {
        console.error("❌ Error fetching citation publisher suggestions:", error);
        return [];
    }
};

// Fetch Vol No.
export const fetchPublisherVolumeSuggestions = async (prefix, citationLocalYear, citationPublisher) => {
    const token = localStorage.getItem("token") || "";
    const axios = (await import("axios")).default;

    const payload = {
        prefix,
        year: citationLocalYear,
        publisher: citationPublisher,
    };

    const url = `${baseURL}/quick-search/citation-volume-suggestion?size=50`;

    try {
        const response = await axios.post(
            url,
            payload,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return response.data || [];
    } catch (error) {
        console.error("❌ Error fetching citation volume suggestions:", error);
        return [];
    }
};

// Fetch Page No.
export const fetchPublisherPageSuggestions = async (prefix, citationLocalYear, citationPublisher, citationVolume) => {
    const token = localStorage.getItem("token") || "";
    const axios = (await import("axios")).default;

    const payload = {
        prefix,
        year: citationLocalYear,
        publisher: citationPublisher,
        volume: citationVolume,
    }
    console.log("Citation Page Paylload", payload)
    try {
        const response = await axios.post(
            `${baseURL}/quick-search/citation-page-suggestion?size=50`,
            payload,
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return response.data || [];
    } catch (error) {
        console.error("Error fetching citation page suggestions:", error);
        return [];
    }
};